import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/neos': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M415.4 512h-95.1l-108.2-154.5v91.1l-86.4 63.4h-97.7v-482.2l40.5-29.8h108l123.7 176.1v-112.7l86.4-63.5h97.7v461.5zM38.8 35.3v460.7l72-52.9v-249.1l215.5 307.6h84.8l52.4-38.2h-78.3l-316.1-450.5zM121.3 501.9l80-58.8v-101l-79.8-114.4v220.9l-72.5 53.3h72.3zM80.6 10.8l310.6 442.6h82.4v-442.6h-79.8v317.6l-222.9-317.6h-90.3zM311 191.6l72 102.8v-278.5l-72 53v122.7z'
      }
    ]
  }
})
